module.exports = __webpack_public_path__ + "img/2.5fbb0d29.jpg";